var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileNavLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H23V23H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(258.413 .412)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.832,
    cy: 1.832,
    r: 1.832,
    fill: "#1c9ad6",
    opacity: 0.2,
    transform: "translate(-248.334 8.877)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c9ad6",
    fillRule: "evenodd",
    d: "M-246.521 16.076a5.306 5.306 0 0 0-4.56 2.316 6.7 6.7 0 0 0 4.411 1.59c3.474 0 4.641-1.7 4.641-1.7a5.341 5.341 0 0 0-4.492-2.206z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#03002f",
    fillRule: "evenodd",
    d: "M-239.2 17.7a8.654 8.654 0 0 0-4.7-3.634 4.239 4.239 0 0 0 1.665-3.355 4.265 4.265 0 0 0-4.265-4.262 4.267 4.267 0 0 0-4.261 4.261 4.238 4.238 0 0 0 1.665 3.355 8.654 8.654 0 0 0-4.7 3.634 9.542 9.542 0 0 1-2.287-6.2 9.6 9.6 0 0 1 9.583-9.586 9.6 9.6 0 0 1 9.587 9.588 9.542 9.542 0 0 1-2.287 6.2m-10.235-6.989a2.938 2.938 0 0 1 2.935-2.937 2.938 2.938 0 0 1 2.935 2.935 2.938 2.938 0 0 1-2.935 2.935 2.938 2.938 0 0 1-2.935-2.935m2.935 10.377a9.532 9.532 0 0 1-6.365-2.438c.016-.022.042-.032.057-.057a7.336 7.336 0 0 1 6.308-3.621 7.337 7.337 0 0 1 6.307 3.619.641.641 0 0 0 .054.063 9.539 9.539 0 0 1-6.361 2.434m0-20.5A10.927 10.927 0 0 0-257.413 11.5 10.925 10.925 0 0 0-246.5 22.412 10.925 10.925 0 0 0-235.587 11.5 10.927 10.927 0 0 0-246.5.588"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNavLogo);
export default __webpack_public_path__ + "static/media/profileNavLogo.46d43ede186329f4e3516621343a934e.svg";
export { ForwardRef as ReactComponent };